import { Skeleton, Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import { useDataMigration } from '@pages/DataMigration/hooks/useDataMigration';

import { columns } from '@pages/DataMigration/data/columns';

import type { FC } from 'react';

import '@pages/DataMigration/styles/DataMigration.mobile.scss';

export const DataMigration: FC = () => {
  const {
    isRegistryLoading,
    hasUserRightForModuleView,
    isMobile,
    pageNumber,
    rowsPerPage,
    handleChange,
    dataSource,
  } = useDataMigration();

  if (isRegistryLoading) {
    return <Skeleton active />;
  }

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="DataMigration">
      <Table
        className="DataMigration__table"
        dataSource={dataSource}
        columns={columns}
        rowClassName="migration-item"
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 500 }}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            generateSpanWithDataTestId(
              isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`,
              'pagination-info'
            ),
          pageSize: rowsPerPage,
          current: pageNumber,
          onChange: handleChange,
        }}
      />
    </div>
  );
};
